import React from "react";


import {
    Col, Row
} from "react-bootstrap";


import {
    SvgIconComponent
} from "@Components/Elements";


import "./index.scss";


type DashboardInfoCardType =
    'neutral' | 'accent' | 'success' | 'warning' | 'info' | 'error' | 'state'
;

type DashboardInfoCardSizeType = 'sm' | 'md' | 'lg';

interface DashboardInfoCardElementComponentProps {
    cardIcon: string;
    cardHeaderText: string;
    cardContentText?: string;
    cardDescriptionText?: string;
    cardSize?: DashboardInfoCardSizeType;
    cardType?: DashboardInfoCardType;
}


export const DashboardInformationCardElementComponent:React.FC<DashboardInfoCardElementComponentProps> = ({
    cardIcon, cardHeaderText, cardContentText, cardDescriptionText,
    cardSize = 'md', cardType = 'neutral'
}) => {

    return (
        <Col className={`dashboard-information-card-element-component ${cardSize}-information-card-element ${cardType}-information-card-element`}>
            <Row className={`dashboard-info-card-element-component__content`}>

                <Col xs={12} className={'information-card-element-header'}>
                    <SvgIconComponent iconSource={cardIcon} className={'information-card-element-header__header-icon'} />
                    <span className={'information-card-element-header__header-text'}>{cardHeaderText}</span>
                </Col>

                {cardContentText &&
                <Col xs={12} className={'information-card-element-content'}>
                    <span>{cardContentText} </span>
                </Col>
                }

                {cardDescriptionText &&
                <Col xs={12} className={'information-card-element-description'}>
                    <span>{cardDescriptionText}</span>
                </Col>
                }

            </Row>
        </Col>
    );

};


export default DashboardInformationCardElementComponent;
